function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "none"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_25",
  "data-name": "Group 25",
  transform: "translate(-1535 -159)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_15",
  "data-name": "Ellipse 15",
  transform: "translate(1535 159)",
  fill: "#fff",
  stroke: "#5485bb",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 18,
  cy: 17,
  rx: 18,
  ry: 17,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 18,
  cy: 17,
  rx: 17.5,
  ry: 16.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Backward_arrow",
  "data-name": "Backward arrow",
  transform: "translate(1561 184) rotate(180)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_10",
  "data-name": "Path 10",
  d: "M8,0,6.545,1.455l5.506,5.506H0V9.039H12.052L6.545,14.545,8,16l8-8Z",
  transform: "translate(16 16) rotate(180)",
  fill: "#5485bb"
})));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 36,
  height: 34,
  viewBox: "0 0 36 34"
}, props), _ref, _ref2);

export default __webpack_public_path__ + "static/media/forward-arrow.e38186cc.svg";
export { SvgComponent as ReactComponent };